import { IdName } from './app';
import { Evaluation } from './evaluations';
import { GeoPoint } from './geoModels';

export enum DeviceGpsType {
  tracking = 1,
  obd,
  camera,
}

export interface Device {
  _id: string;
  ident: string;
}

export interface SecondaryDevice extends Device {}

export interface SecondaryDeviceDetail {
  battery_percentage: number;
  created: string;
  engine_ignition_status: number;
  external_powersource_voltage: number;
  geoReference: string;
  gnss_vehicle_mileage: number;
  gsm_signal_dbm: number;
  ident: string;
  lastModified: string;
  point: GeoPoint;
  position_direction: number;
  position_latitude: number;
  position_longitude: number;
  position_satellites: number;
  position_speed: number;
  positionType: string;
  power_on_status: boolean;
  timestamp: string;
  isPrimary: boolean;
  device: Device;
  color?: string;
}

export interface MultipleDevice {
  devices: SecondaryDeviceDetail[];
  evaluations: Evaluation[];
}

export interface DeviceMedia {
  _id: string;
  ident: string;
  brand: IdName | string;
  model: IdName | string;
  carrier: string;
  imei: string;
  sim: string;
  maxMb: number;
  gpsType: DeviceGpsType;
}
